import domain from './domain';

// Reset task category featured blocks
export const resetTaskCategoryFeaturedBlocks = domain.createEvent('resetTaskCategoryFeaturedBlocks');

// Reset task categories
export const resetTaskCategories = domain.createEvent('resetTaskCategories');
